type Props = {
  arr: any[];
  from: number;
  to: number;
  isMutate?: boolean;
};

const isNotInRange = ({ arr, from, to }: Props) => {
  const { length } = arr;

  return (
    !Array.isArray(arr) ||
    typeof from !== 'number' ||
    typeof to !== 'number' ||
    from < 0 ||
    to < 0 ||
    to > length ||
    from > length
  );
};

const move = ({ arr, from, to, isMutate = true }: Props) => {
  if (isNotInRange({ arr, from, to })) return arr;

  const modified = isMutate ? arr : arr.slice();

  modified.splice(to, 0, modified.splice(from, 1)[0]);

  return modified;
};

export default move;
